export const robots = [
  { 
    id: 1,
    name: 'Netflix clone',
    username: 'A video streaming site built with ReactJS',
    email: 'Sincere@april.biz',
    github:'https://github.com/nilutpalbr/Netflix-clone',
    website: 'https://netflix-clone-7836a.web.app/',
  },
  {
    id: 2,
    name: 'Gradient Background generator',
    username: 'Gradient background generator built with HTML,CSS,JavaScript',
    email: 'Shanna@melissa.tv',
    github:'https://github.com/nilutpalbr/Gradient-Background-generator',
    website: 'https://nilutpalbr.github.io/Gradient-Background-generator/',

  },
  {
    id: 3,
    name: 'Google Search page clone',
    username: 'Google search page clone',
    email: 'Nathan@yesenia.net',
    github:'https://github.com/nilutpalbr/google-search-engine-clone',
    website: 'https://nilutpalbr.github.io/google-search-engine-clone/',
  },
];
